import { ChangeDetectionStrategy, Component } from '@angular/core';
import { industriesData, Industry } from './industry';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-industries',
  templateUrl: './industries.component.html',
  styleUrls: ['./industries.component.scss'],
  imports: [TranslatePipe, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndustriesComponent {
  public readonly industries: Industry[] = industriesData;
}
